export const claimCodes = {
    missingGoods: 1,
    pickError: 3,
    damagedGoods: 4,
    pickErrorCustomerKeep: 6,
    wrongOrder: 7,
    transportDamage: 10,
    dateExpired: 11,
    badTemperature: 24,
};

// Nicely used in dropdown
export const claimCodeOptions = [
    {
        value: claimCodes.missingGoods,
        label: "Manko",//MissingGoods (Cannot be used when ReturnGoods is set)
    },
    {
        value: claimCodes.pickError,
        label: "Plukkfeil, returnerer",//PickError (Return goods must be set)
    },
    {
        value: claimCodes.damagedGoods,
        label: "Beskadiget vare",//DamagedGoods MissingGoods
    },
    {
        value: claimCodes.pickErrorCustomerKeep,
        label: "Plukkfeil, beholder",//PickErrorCustomerKeep (Cannot be used when ReturnGoods is set)
    },
    {
        value: claimCodes.wrongOrder,
        label: "Feilbestilt",//WrongOrder
    },
    {
        value: claimCodes.transportDamage,
        label: "Transportskade",//TransportDamage
    },
    {
        value: claimCodes.dateExpired,
        label: "Dårlig holdbarhetsdato",//DateExpired
    },
    {
        value: claimCodes.badTemperature,
        label: "Dårlig temperatur",//BadTemperature
    },
];